import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  CircularProgress,
  Grid,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

import DocumentDetail from "./DocumentDetail";

export default function DocumentsTable({
  title,
  loading,
  items,
  handleAdd,
  handleEdit,
}) {
  const [data, setData] = useState([]);
  const [rowsExpanded, setRowsExpanded] = useState([]);

  const columns = [
    {
      name: "DOCUMENT_ID",
      label: "#",
    },
    {
      name: "PROJECT_DESCRIPTION",
      label: "Project",
    },
    {
      name: "JOB_DESCRIPTION",
      label: "Job",
    },
    {
      name: "TITLE",
      label: "Title",
    },
    {
      name: "DESCRIPTION",
      label: "Description",
    },
    {
      name: "SUPPLIER_USERNAME",
      label: "Supplier",
    },
    {
      name: "CREATE_DATE",
      label: "Created at",
      options: {
        display: false,
      },
    },
    {
      name: "LAST_UPDATED",
      label: "Updated at",
      options: {
        display: false,
      },
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    expandableRows: true,
    rowsExpanded: rowsExpanded,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;
      const rowIndex = rowMeta.rowIndex;
      const selectedRow = data[rowIndex];

      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <Grid container alignItems="center" spacing={4}>
              <Grid item xs={12}>
                <DocumentDetail data={selectedRow} handleSave={handleEdit} />
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
      );
    },
    customToolbar: () => {
      return handleAdd ? (
        <Button
          size="small"
          color="primary"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          disabled={loading}
        >
          Add
        </Button>
      ) : (
        <></>
      );
    },
  };

  useEffect(() => {
    if (items !== null) {
      setData([...items]);
    }
  }, [items]);

  const handleRowExpandToggle = (rowData) => {
    const expandedRowIndex = rowsExpanded.indexOf(rowData.index);

    if (expandedRowIndex === -1) {
      // Row is currently not expanded, so add it to the rowsExpanded array
      setRowsExpanded([...rowsExpanded, rowData.index]);
    } else {
      // Row is currently expanded, so remove it from the rowsExpanded array
      setRowsExpanded(rowsExpanded.filter((index) => index !== rowData.index));
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5">{title}</Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress size="1rem" />
                </Grid>
              )}
            </Grid>
          }
          data={data}
          columns={columns}
          options={options}
          onRowExpansionChange={handleRowExpandToggle}
        />
      </Grid>
    </Grid>
  );
}
